import correctSound from "../sound/correct-tone.wav";
import wrongSound from "../sound/false-tone.wav";

class SoundEffects {
  static correct = new Audio(correctSound);
  static wrong = new Audio(wrongSound);

  static playCorrect() {
    this.correct.currentTime = 0;
    this.correct.play();
  }

  static playWrong() {
    this.wrong.currentTime = 0;
    this.wrong.play();
  }
}

export default SoundEffects;
